import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ForgotPassword: React.FC = () => {
  const [username, setUsername] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const { forgotPassword } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const success = await forgotPassword(username);
      if (success) {
        setMessage('Password reset link has been sent to your email address.');
      } else {
        setError('Failed to send reset link. Please check your username and try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="account-pages my-5 pt-sm-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card overflow-hidden">
              <div className="bg-primary-subtle" style={{ backgroundColor: '#00617520' }}>
                <div className="row">
                  <div className="col-7">
                    <div className="text-primary p-4" style={{ color: '#006175' }}>
                      <h5 className="text-primary" style={{ color: '#006175' }}>Reset Password</h5>
                      <p>Enter your username to receive a password reset link.</p>
                    </div>
                  </div>
                  <div className="col-5 align-self-end">
                    <img src="/assets/images/header_logo.png" alt="Nyvro Logo" className="img-fluid" style={{ maxHeight: '72px', objectFit: 'contain' }} />
                  </div>
                </div>
              </div>
              <div className="card-body pt-0">
                <div className="auth-logo">
                  <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                      <img src="/assets/images/colored_logo.png" alt="Nyvro" height="34" style={{ objectFit: 'contain' }} />
                    </span>
                  </div>
                </div>
                <div className="p-2">
                  <form onSubmit={handleSubmit}>
                    {error && (
                      <div className="alert alert-danger" role="alert">
                        {error}
                      </div>
                    )}

                    {message && (
                      <div className="alert alert-success" role="alert">
                        {message}
                      </div>
                    )}

                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">Username or Email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="username"
                        placeholder="Enter your username or email"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        disabled={isLoading}
                      />
                    </div>

                    <div className="mt-3 d-grid">
                      <button
                        className="btn btn-primary waves-effect waves-light"
                        type="submit"
                        disabled={isLoading}
                        style={{ backgroundColor: '#006175', borderColor: '#006175' }}
                      >
                        {isLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                        ) : (
                          'Send Reset Link'
                        )}
                      </button>
                    </div>

                    <div className="mt-4 text-center">
                      <Link to="/login" className="text-muted">
                        <i className="mdi mdi-arrow-left me-1"></i> Back to Login
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="mt-5 text-center">
              <div>
                <p>
                  <small className="text-muted">
                    Nyvro Admin Panel - Developed by{' '}
                    <span style={{ color: '#006175', fontWeight: 'bold' }}>Midnite Spark</span>
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
